(function(){
  'use strict';

  /* FIX (2026-08-01): this file was being executed TWICE on every page except the
     PeekoraScope PDP, which is what broke the PayPal / Shop Pay layout in the
     mini cart.

     sections/pk-mini-cart.liquid injects this script via an inline guard:

       if (document.querySelector('script[src*="pk-commerce-brand-sync"]')) return;

     That guard runs DURING PARSING of the mini-cart section. theme.liquid renders
     the mini-cart section well before its own
     {% unless is_scope_pdp %} ... pk-commerce-brand-sync.js ... {% endunless %}
     block further down the document. So at guard time the later <script> tag did
     not exist in the DOM yet, the guard found nothing, injected a copy into
     <head>, and the parser then added the second tag anyway.

     Both copies bound listeners to peekora:cart:updated, peekora:cart:changed and
     shopify:section:load, and both called insertAdjacentElement() on the SAME
     #PkOfficialAcceleratedCheckout node. insertAdjacentElement MOVES a live node:
     each call detached and re-attached <shopify-accelerated-checkout>, firing
     disconnectedCallback/connectedCallback. Shopify's wallet buttons re-measure
     on reconnect, so being torn out and reinserted twice per cart event - while
     the drawer was still mid-transform and therefore effectively zero-size -
     made them size against nothing and render collapsed, stacked, or full-bleed.

     Note this only reproduced OFF the PeekoraScope PDP: on that template
     is_scope_pdp is true, the {% unless %} block is skipped, and only the
     mini-cart injector loaded the file - one copy, correct layout.

     Two guards below rather than one. The re-entry flag makes the duplicate tag
     harmless (same approach as pk-bogo-cart-display.js), and the placement check
     makes relocation idempotent so the repeated cart events cannot re-initialise
     the wallet buttons for no reason. theme.liquid is intentionally left alone. */
  if(window.__PK_COMMERCE_BRAND_SYNC__)return;
  window.__PK_COMMERCE_BRAND_SYNC__=true;

  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}

  /* FIX (2026-08-02): the drawer target moved from .pkmc__checkout to the
     "Express checkout" divider inside the drawer's SCROLL area.

     Landing these four full-height wallet buttons next to the checkout button
     put ~230px of runtime-injected content into the drawer's PINNED footer.
     The footer was flex:0 0 auto, so it could not give that height back, and on
     a 375x812 phone the product list collapsed to about 20px - customers could
     not scroll to their own cart items. Checkout controls must not be behind a
     scroll, so the pinned footer is now a bounded set (totals, one checkout
     button, payment icons) and the wallet buttons live in the scroll area.

     The fallback keeps this file working against the previous markup, so the
     mini-cart section can be rolled back on its own without breaking wallets. */
  function drawerTarget(){
    return document.querySelector('[data-pkmc-wallet-anchor]') ||
           document.querySelector('.pkmc__checkout');
  }

  function placeOfficialCheckout(){
    document.querySelectorAll('[data-pk-fastpay],.pk-commerce-fastpay').forEach(function(node){node.remove();});

    var official=document.getElementById('PkOfficialAcceleratedCheckout');
    if(!official)return;

    var target=document.body.classList.contains('template-cart')
      ? document.querySelector('.pq-cart__checkout')
      : drawerTarget();
    if(!target)return;

    /* Only move when it is not already sitting where it belongs. Re-running
       insertAdjacentElement on a node that is ALREADY the target's next sibling
       still detaches and re-attaches it, which restarts the wallet buttons'
       measure cycle for no benefit. This fires on every cart change, so the
       no-op path matters more than the move path. */
    if(target.nextElementSibling!==official){
      target.insertAdjacentElement('afterend',official);
    }

    /* Unpark only once the block is inside the drawer and can measure a real
       width. It ships parked off-screen with visibility:hidden rather than the
       old `hidden` attribute (display:none) precisely so the buttons have
       dimensions while they boot. See snippets/pk-official-accelerated-checkout. */
    official.hidden=false;
    official.classList.remove('is-parked');
  }

  function enhance(){placeOfficialCheckout();}

  // The bundle perks are rendered by the section now; this only has to relocate
  // the accelerated-checkout block once the cart markup exists.
  ready(enhance);
  document.addEventListener('peekora:cart:updated',enhance);
  document.addEventListener('peekora:cart:changed',enhance);
  document.addEventListener('shopify:section:load',enhance);
})();
